
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AngularTokenService } from '@raysuelzer/angular-token';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * If user is already logged in, skip the login page.
 */
export function loginFunctionalGuard(): CanActivateFn {
  return (_route, _state) => {
    const tokenService = inject(AngularTokenService)
    const router = inject(Router)
    return tokenService
      .validateToken().pipe(
        map((r) => {
          return router.parseUrl('/');
        }),
        catchError((e) => observableOf(true))); // user not logged
  }
}
